import styled from "styled-components";

export const Card = styled.div`
  position: relative;
  padding: 16px;
  background: linear-gradient(
    180deg,
    rgba(198, 224, 232, 0.15) 0%,
    rgba(184, 194, 226, 0.15) 100%
  );
  border-radius: 16px;
  border: 1px solid rgba(10, 13, 18, 0.1);
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #2258f1;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  &.selected {
    border-color: #2258f1;
    background: ${({ theme }) => theme.card.bg.hover};
  }

  &:active {
    transform: translateY(0);
  }
`;

export const CardWrapper = styled.div`
  margin-bottom: 12px;
`;

export const Label = styled.div`
  font-size: 12px;
  color: #414651;
  font-weight: 500;
  font-family: "Geist", sans-serif;
  background: #fafafa;
  border-radius: 6px;
  border: 1px solid #e9eaeb;
  display: inline-block;
  padding: 2px 6px;
  margin-bottom: 12px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  flex-wrap: wrap;
`;

export const LeftSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const RightSection = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 8px;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Heading = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: rgba(10, 13, 18, 0.9);
  font-family: "Geist", sans-serif;
  margin-bottom: 18px;
`;

export const Checklist = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ChecklistItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const IconWrap = styled.span`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
  }
`;

export const ChecklistText = styled.span`
  color: #717885;
  font-size: 14px;
  font-weight: 500;
  font-family: "Geist", sans-serif;
`;
